<template>
  <v-card>
    <v-card-title class="title">{{ $t('title.transactions') }} ({{ $t('transactions.recent_days', { num: 30 }) }}) - {{ franchiseeLocation ? franchiseeLocation.display_name : $t('not_yet_allocated') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="list"
        :items-per-page="pagination.itemsPerPage"
        :options.sync="pagination"
        :server-items-length="totalItems"
        hide-default-footer
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ pagination.itemsPerPage * (pagination.page - 1) + index + 1 }}</td>
            <td>{{ timestampToDatetime(item.time) }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ startCase(item.payment_method) }}</td>
          </tr>
        </template>

        <tr slot="footer">
            <td colspan="5">
              <v-layout row mt-3 text-center>
                <v-pagination :length="pages" v-model="pagination.page" :total-visible="7"></v-pagination>
              </v-layout>
            </td>
        </tr>

        <div slot="no-data" class="text-center">
          {{ $t('data_table.no_data') }}
        </div>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { startCase } from 'lodash'
import moment from 'moment'

import reportService from '@/services/report'

export default {
  props: {
    machine: Object,

    franchiseeLocation: Object
  },

  data () {
    return {
      loading: false,

      list: [],
      totalItems: 0,
      pages: 0,

      pagination: {
        page: 1,
        itemsPerPage: 10,
        descending: true,
        sortBy: ['time']
      },
      headers: [
        { text: '', value: '', sortable: false },
        { text: this.$t('transactions.time'), value: 'time', sortable: false },
        { text: this.$t('transactions.product_name'), value: 'name', sortable: false },
        { text: this.$t('transactions.amount'), value: 'amount', sortable: false },
        { text: this.$t('transactions.payment_method'), value: 'payment_method', sortable: false }
      ]
    }
  },

  watch: {
    pagination: {
      deep: true,
      handler () {
        this.load()
      }
    }
  },

  created () {
    this.load()
  },

  methods: {
    startCase,

    async load () {
      this.loading = true
      const { page, itemsPerPage } = this.pagination

      try {
        const { data } = await reportService.getMachineTransactions(this.machine.id, itemsPerPage, page)
        this.list = data.data.data
        this.totalItems = data.data.total
        this.pages = data.data.last_page
      } catch (e) {
        this.$toasted.error(this.$t('error_message')).goAway(5000)
      } finally {
        this.loading = false
      }
    },

    timestampToDatetime (timestamp) {
      if (!timestamp) {
        return
      }
      return moment.unix(timestamp).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
